/**
 * Default processor for RTK Query responses.
 * Returns the response as-is. Can be replaced with custom logic if needed.
 * @template T - The type of the response.
 * @param {T} response - The response object to process.
 * @returns {T} The processed response (unchanged).
 */
export const processResponse = <T>(response: T): T => response;

/**
 * Default processor for RTK Query errors.
 * Returns the error in a consumable store friendly object. Can be replaced with
 * custom logic if needed.
 * @param {any} error - The error object to process.
 * @returns {{ message: string; status: number | string }} The processed error state.
 */
export const processError = (error: any) => {
  const errorState = {
    message: error.response?.data?.message ?? 'An unknown error occurred',
    status: error.response?.status ?? 'Unknown'
  };
  console.log('Processed error state:', errorState);
  return errorState;
};
